import React from 'react';
import getIsInFedEnvironment from '@lifeomic/phc-web-toolkit/src/util/getIsInFedEnvironment';
import { useDispatch } from 'react-redux';
import { authActions } from '@lifeomic/phc-web-toolkit/src/redux/modules/auth';
import IdleTimer from 'react-idle-timer';

const isInFedEnv = getIsInFedEnvironment();

const FedrampIdleTimeout = () => {
  const dispatch = useDispatch();
  if (!isInFedEnv) return null;

  return (
    <IdleTimer
      timeout={1000 * 60 * 15}
      onIdle={() => dispatch(authActions.globalLogout())}
    />
  );
};

export default React.memo(FedrampIdleTimeout);
